<template>
  <div class="tile-section section-1 " style="display: flex; justify-content: space-between;">
      <b-card
      no-body
      class="overflow-hidden card-item"
      :class="{
        'mobile-card':
          $router.history.current.path == '/th' ||
          $router.history.current.path == '/en' ||
          $router.history.current.path == '/th/' ||
          $router.history.current.path == '/en/' ||
          $router.history.current.name == 'SellerDetail' ||
          $router.history.current.name == 'ListingDetail',
      }"
    >
    <b-col md="12" style="position: relative; padding: 0" >
        <div class="timeline-item box">
            <div class="animated-background">
                
                <div class="background-masker header-bottom"></div>
                
                <div class="background-masker header-left"></div>
                <div class="background-masker header-right"></div>
                <div class="background-masker header-top"></div>
                <div class="background-masker subheader-left"></div>
                <div class="background-masker subheader-right"></div>
                <div class="background-masker subheader-bottom"></div>
                <div class="background-masker content-top"></div>
                <div class="background-masker content-first-end"></div>
                <div class="background-masker content-second-line"></div>
                <div class="background-masker content-second-end"></div>
                <div class="background-masker content-third-line"></div>
                <div class="background-masker content-third-end"></div>
            </div>
        </div>
    </b-col>
      </b-card>
    </div>
</template>
<script>
export default {
  name: "CardSkeleton",
  components: {},
  data() {
    return {};
  },
};
</script>
<style lang="scss">
@import "style.scss";

.timeline-item {
  background-color: #fff;
  border: 1px solid;
//   border-color: #e5e6e9 #dfe0e4 #d0d1d5;
  border-radius: 3px;
  padding: 12px;
  height: 100%;
  border:none;
}
@keyframes placeHolderShimmer {
  0% {
    background-position: -468px 0;
  }
  100% {
    background-position: 468px 0;
  }
}
.animated-background {
  animation-duration: 0.7s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  animation-name: placeHolderShimmer;
  background: #f6f7f8;
  background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);
  background-size: 800px 104px;
  height: 100%;
  position: relative;
}
.background-masker {
  background: #fff;
  position: absolute;
}
/* Every thing below this is just positioning */
.background-masker.header-top,
.background-masker.header-bottom,
.background-masker.subheader-bottom {
  bottom: 12px;
  left: 40px;
  right: 0;
  height: 10px;
}
.background-masker.header-left,
.background-masker.subheader-left,
.background-masker.header-right,
.background-masker.subheader-right {
  bottom: 30px;
  left: 40px;
  height: 8px;
  width: 10px;
}
.background-masker.header-bottom {
  bottom: 88px;
  height: 6px;
}
.background-masker.subheader-left,
.background-masker.subheader-right {
  bottom: 25px;
  height: 6px;
}
.background-masker.header-right,
.background-masker.subheader-right {
  width: auto;
  left: 93%;
  right: 0;
}
.background-masker.subheader-right {
  left: 85%;
}
.background-masker.subheader-bottom {
  bottom: 108px;
  height: 10px;
}
.background-masker.content-top,
.background-masker.content-second-line,
.background-masker.content-third-line,
.background-masker.content-third-end,
.background-masker.content-first-end {
  bottom: 56px;
  left: 0;
  right: 0;
  height: 6px;
}
.background-masker.content-top {
  height: 20px;
  bottom: 56px;
}
.background-masker.content-first-end,
.background-masker.content-second-end,
.background-masker.content-third-end {
  width: auto;
  left: 87%;
  right: 0;
  bottom: -1px;
  height: 8px;
}
.background-masker.content-second-line {
  bottom: 6px;
}
.background-masker.content-second-end {
  left: 97%;
  bottom: 61px;
}
.background-masker.content-third-line {
  bottom: 20px;
}
.background-masker.content-third-end {
  left: 78%;
  bottom: 38px;
}
.background-masker.header-top,
.background-masker.header-bottom,
.background-masker.subheader-left,
.background-masker.subheader-bottom {
  left: 0px;
}
.background-masker.header-left,
.background-masker.subheader-left {
  width: 0px;
}
</style>